var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcCopy = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 2H16C16.55 2 17 2.45 17 3C17 3.55 16.55 4 16 4H6C5.45 4 5 4.45 5 5V17C5 17.55 4.55 18 4 18C3.45 18 3 17.55 3 17V4C3 2.9 3.9 2 5 2Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 8H9V20H19V8ZM9 6C7.89543 6 7 6.89543 7 8V20C7 21.1046 7.89543 22 9 22H19C20.1046 22 21 21.1046 21 20V8C21 6.89543 20.1046 6 19 6H9Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcCopy);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-copy.321559b6991d1a8082c589930162547f.svg";